

























import { Component, Prop, Vue, Watch, Model, Emit } from 'vue-property-decorator';
// import { Rate } from 'element-ui';
@Component({
  name: 'lb-rate'
  // components: {
  //   'el-rate': Rate
  // }
})
export default class extends Vue {
  @Model() private value!: number;
  @Prop({ default: 2 }) private lowThreshold!: number;
  @Prop({ default: 4 }) private highThreshold!: number;
  @Prop({ default: 5 }) private max!: number;
  @Prop({
      default() {
          return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
      }
  }) private colors!: object | any[];
  @Prop({ default: '#C6D1DE' }) private voidColor!: string;
  @Prop({ default: '#EFF2F7' }) private disabledVoidColor!: string;
  @Prop({
      default() {
          return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
      }
  }) private iconClasses!: object | any[];
  @Prop({ default: 'el-icon-star-off' }) private voidIconClass!: string;
  @Prop({ default: 'el-icon-star-on' }) private disabledVoidIconClass!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop({ type: Boolean, default: false }) private allowHalf!: boolean;
  @Prop({ type: Boolean, default: false }) private showText!: boolean;
  @Prop({ type: Boolean, default: false }) private showScore!: boolean;
  @Prop({ default: '#1f2d3d' }) private textColor!: string;
  @Prop({
      default() {
          return ['极差', '失望', '一般', '满意', '惊喜'];
      }
  }) private texts!: any[];
  @Prop({ default: '{value}' }) private scoreTemplate!: string;

  private localValue: number = this.value

  @Emit()
  change(n: number) {
      return n
  }
}
